import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"

import "./Table.vue?vue&type=style&index=0&id=7e0b20f7&lang=postcss"

const __exports__ = script;

export default __exports__